import React from "react";
import { Box, Typography, Link } from "@mui/material";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        py: 3,
        px: 4,
        backgroundColor: "black",
        color: "white",
        borderTop: "1px solid #ddd",
      }}
    >
      {/* Left Side: Powered by text */}
      <Typography
        variant="body2"
        sx={{
          fontFamily: "SangBleu Empire Trial",
          fontWeight: 500,
        }}
      >
        2024 © Hotel City Plaza International, All rights reserved.
      </Typography>

      {/* Right Side: Powered by text with Facebook link */}
      <Typography
        variant="body2"
        sx={{
          fontFamily: "SangBleu Empire Trial",
          fontWeight: 500,
        }}
      >
        Powered by{" "}
        <Link
          href="https://www.iciclecorporation.com/"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: "white",
            textDecoration: "none",
            "&:hover": {
              textDecoration: "underline",
              color: "green",
              
            },
          }}
        >
          Icicle Corporation
        </Link>
      </Typography>
    </Box>
  );
};

export default Footer;
